<template>
  <div class="banner-card" v-if="banner.text" @click="goWithdraw">
    <div class="title">{{banner.text}}</div>
    <div class="pop" v-html="popText"></div>
    <div class="cat"></div>
  </div>
</template>

<script>
export default {
  props: {
    banner: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    popText () {
      if (this.banner?.pop && this.banner?.pop.indexOf('$') > -1) {
        return this.banner.pop.replace('$', '<br>')
      }
      return ''
    }
  },
  data () {
    return {
      visible: true
    }
  },
  methods: {
    goWithdraw () {
      this.$sensors.track('$WebClick', { element_type: this.banner.textKey, element_pop_type: this.banner.popKey })
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.banner-card {
  width: 670px;
  height: 130px;
  background: #FFECE4;
  border-radius: 20px;
  position: relative;
  margin:20px auto 0;
  padding: 23px 30px ;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #B13314;
    width: 320px;
  }
  .pop {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #B13314;
    line-height: 28px;
    position: absolute;
    width:109px;
    height:109px;
    background: url('./images/img_qipa.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    right: 174px;
    top:-13px;
    animation: pop 0.8s  infinite alternate;
  }
  @keyframes pop {
    0% {
      transform: translateY(-5px);
    }
    100% {
      transform: translateY(10px);
    }
    
  }
  .cat {
    width:170px;
    height:130px;
    background:url('./images/img_mao.png') no-repeat;
    background-size: 4250px 130px;
    position: absolute;
    right: 0;
    top: 0;
    animation: cat steps(25) infinite 1s;
  }
  @keyframes cat {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -4250px 0;
    }
  }
}
</style>